// Provides React to Module Federation remotes via the shared scope.
// window.React is set by setupMfGlobals.js at host startup.
module.exports = typeof window !== 'undefined' ? window.React : undefined;
